<template>
  <div class="material">
    <van-row class="cell-row border">
      <van-col span="6" class="left-label">当前状态</van-col>
      <van-col span="18" class="right-content">
        <span v-show="infoCompleted" class="collected">已收齐</span>
        <span v-show="!infoCompleted" class="not-collected">未收齐</span>
        <van-switch
          active-color="#138FFF"
          inactive-color="#A4ACB5"
          :value="infoCompleted"
          @input="onSwitchInput"
        />
      </van-col>
    </van-row>
    <van-row class="cell-row border interval">
      <van-col span="6" class="left-label">已收明细：</van-col>
      <van-col span="18" class="right-content">
        <span class="select-all" @click="selectAll">全选</span>
      </van-col>
    </van-row>
    <van-checkbox-group v-model="result" ref="checkboxGroup">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in documentList"
          clickable
          :key="item.nodeItemId"
          :title="`${item.document}`"
          @click="toggle(index)"
        >
          <template #right-icon>
            <div class="point"></div>
            <van-checkbox :name="item" ref="checkboxes"/>
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <van-row class="cell-row border interval">
      <van-col span="24" class="left-label">其他：</van-col>
      <van-col span="24" class="textarea-wrap">
        <van-field placeholder="请输入备注信息" rows="4" maxlength="500" type="textarea" v-model="remark"/>
      </van-col>
    </van-row>
    <van-row class="btnRow" @click.native="confirmClick">确定</van-row>
  </div>
</template>

<script>
import Vue from "vue";
import * as math from "mathjs";
import {
  Row,
  Col,
  Icon,
  Switch,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Field,
  Toast
} from "vant";
import { setTimeout } from "timers";
Vue.use(Row)
  .use(Col)
  .use(Icon)
  .use(Switch)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Field)
  .use(Toast);

export default {
  name: "material",
  components: {},
  data() {
    return {
      businessService: this.$store.state.businessServiceInfo,
      infoCompleted: this.$store.state.businessServiceInfo.infoCompleted == 1,
      result: [],
      documentList: [],
      remark: this.$store.state.businessServiceInfo.otherdoc || "",
      allSelect: false
    };
  },
  methods: {
    //js精度计算
    printFn(value) {
      const precision = 14;
      return Number(math.format(value, precision));
    },
    init() {
      console.log(this.businessService, "businessService");
      if (this.businessService.documentList) {
        this.documentList = JSON.parse(this.businessService.documentList);
        this.result = this.documentList.filter(p => {
          return p.selected == 1;
        });
      }
    },
    linkSkip(name, params, redType, rid) {
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      this.$router.push({
        name: name,
        query: params
      });
    },
    onSwitchInput(checked) {
      let url =
        "/fc/small/program/document/finish?id=" +
        this.businessService.acctOrderServiceId;
      this.documentList.forEach(p => {
        this.result.forEach(q => {
          if (p.nodeItemId == q.nodeItemId) {
            p.selected = 1;
          }
        });
      });
      let params = {
        documentList: JSON.stringify(this.documentList),
        otherdoc: this.remark,
        status: checked ? 1 : 0
      };

      this.$http
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.infoCompleted = checked;
            let businessServiceInfo = this.$store.state.businessServiceInfo
            businessServiceInfo.infoCompleted = checked
            this.$store.dispatch("setBusinessServiceInfo", businessServiceInfo);
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    selectAll() {
      this.allSelect = !this.allSelect
      this.$refs.checkboxGroup.toggleAll(this.allSelect);
    },
    confirmClick() {
      let url =
        "/fc/small/program/document?id=" + this.businessService.acctOrderServiceId;

      this.documentList.forEach(p => {
        this.result.forEach(q => {
          if (p.nodeItemId == q.nodeItemId) {
            p.selected = 1;
          }
        });
      });
      let params = {
        documentList: JSON.stringify(this.documentList),
        otherdoc: this.remark
      };

      this.$http
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            Toast("保存成功！");
            setTimeout(() => {
              this.$router.push({
                name: "businessServiceDetail",
                query: params
              });
            }, 3000);
            let businessServiceInfo = this.$store.state.businessServiceInfo
            businessServiceInfo.documentList = JSON.stringify(this.documentList)
            businessServiceInfo.otherdoc = this.remark
            this.$store.dispatch("setBusinessServiceInfo", businessServiceInfo);
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    }
  },
  mounted: function() {
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.init();
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.material {
  padding-bottom: 0.64rem;

  .cell-row {
    background-color: #ffffff;
    font-size: 0.16rem;
    padding: 0.12rem 0.16rem;
  }

  .left-label {
    font-weight: bold;
    line-height: 0.36rem;
  }

  .right-content {
    text-align: right;
  }

  .border {
    border-bottom: 1px solid #f0f2f2;
  }

  .interval {
    margin-top: 0.1rem;
  }

  .select-all {
    color: #138FFF;
    line-height: 0.36rem;
  }

  .collected {
    position: absolute;
    z-index: 2;
    top: 0.18rem;
    right: 1.2rem;
    color: #1C2835;
  }

  .not-collected {
    position: absolute;
    z-index: 2;
    top: 0.18rem;
    right: 1.2rem;
    color: #1C2835;
  }

  .point {
    width: 0.06rem;
    height: 0.06rem;
    background-color: #646F7B;
    border-radius: 0.06rem;
    position: absolute;
    top: 0.21rem;
    left: 0.16rem;
  }

  .textarea-wrap {
    border: 1px solid #DDE1E5;
  }

  .btnRow {
    padding: 0.16rem 0.12rem;
    text-align: center;
    color: #ffffff;
    background-color: #138FFF;
    border-top: 1px solid #f0f2f2;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    font-size: 0.17rem;
    box-sizing: border-box;
    font-weight: 500;
  }
}
</style>
<style>
.material .van-switch {
  width: 3em;
}
.material .van-switch--on .van-switch__node {
  transform: translateX(2em);
}
.material .van-checkbox-group .van-cell {
  padding: 0.12rem 0.16rem;
}
.material .van-checkbox-group .van-cell__title {
  padding-left: 0.12rem;
}
.material .van-checkbox-group .van-cell__value {
  display: none;
}
</style>

